interface ITextProps {
    text: string;
}
const Text:React.FC<ITextProps> = ({text}) => {
    return (
        <div style={{ color: 'var(--color-primary)' }}>{text}</div>
    );
}
export default Text;